module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newBanner"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("banner管理 >\n\t\t"), (_vm.edit === false) ? _c('span', [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.edit !== false) ? _c('span', [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存为草稿")]), _vm._v(" "), _c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.issue
    }
  }, [_vm._v("保存并发布")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bannerDetail"
  }, [_c('el-form', {
    ref: "bannerForm",
    staticClass: "bannerForm",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.bannerForm,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "封面图片：",
      "prop": "imgUrl"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": _vm.actionUrl,
      "with-credentials": true,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "on-error": _vm.handleError,
      "on-success": _vm.handleSuccess
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("将文件拖到此处，或\n\t\t\t\t\t\t"), _c('em', [_vm._v("点击上传")])])]), _vm._v(" "), (_vm.bannerForm.positionType == 1) ? _c('span', {
    staticClass: "gray"
  }, [_vm._v("3.0.0版本之前的发现频道：（750x418，格式为jpg、png）")]) : _vm._e(), _vm._v(" "), (_vm.bannerForm.positionType == 2) ? _c('span', {
    staticClass: "gray"
  }, [_vm._v("跑步记录顶部：（750x270， 格式为jpg、png）")]) : _vm._e(), _vm._v(" "), (_vm.bannerForm.positionType == 3) ? _c('span', {
    staticClass: "gray"
  }, [_vm._v("运动音乐顶部：（750x270， 格式为jpg、png）")]) : _vm._e(), _vm._v(" "), (_vm.bannerForm.positionType == 4) ? _c('span', {
    staticClass: "gray"
  }, [_vm._v("首页-为你推荐：（584x240，格式为jpg、png）")]) : _vm._e(), _vm._v(" "), (_vm.bannerForm.positionType == 5) ? _c('span', {
    staticClass: "gray"
  }, [_vm._v("社区-动态：（686x240， 格式为jpg、png）")]) : _vm._e(), _vm._v(" "), (_vm.bannerForm.positionType == 6) ? _c('span', {
    staticClass: "gray"
  }, [_vm._v("3.0.0版本及之后的发现频道：（686x240， 格式为jpg、png）")]) : _vm._e(), _vm._v(" "), (_vm.bannerForm.positionType == 7) ? _c('span', {
    staticClass: "gray"
  }, [_vm._v("问卷调查：（750x270，格式为jpg、png）")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "位置：",
      "prop": "positionType",
      "required": ""
    }
  }, [_c('el-select', {
    staticClass: "place",
    model: {
      value: (_vm.bannerForm.positionType),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "positionType", $$v)
      },
      expression: "bannerForm.positionType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "3.0.0版本之前的发现频道",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "跑步记录顶部",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "运动音乐顶部",
      "value": "3"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "首页-为你推荐",
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "社区-动态",
      "value": "5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "3.0.0版本及之后的发现频道",
      "value": "6"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "问卷调查",
      "value": "7"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-bottom": "18px"
    },
    attrs: {
      "label": "banner名称：",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "banner名称不在app上显示，仅供后台管理参考"
    },
    model: {
      value: (_vm.bannerForm.title),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "title", $$v)
      },
      expression: "bannerForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "bannerContent",
    attrs: {
      "label": "广告曝光代码：",
      "prop": "adExposingCodes"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 5
      },
      "placeholder": "在这里粘贴"
    },
    model: {
      value: (_vm.bannerForm.adExposingCodes),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "adExposingCodes", $$v)
      },
      expression: "bannerForm.adExposingCodes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wx-app",
    attrs: {
      "label": "点击事件：",
      "prop": "clickEvent",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "-1"
    },
    model: {
      value: (_vm.bannerForm.clickEvent),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "clickEvent", $$v)
      },
      expression: "bannerForm.clickEvent"
    }
  }, [_vm._v("无跳转")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "5"
    },
    model: {
      value: (_vm.bannerForm.clickEvent),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "clickEvent", $$v)
      },
      expression: "bannerForm.clickEvent"
    }
  }, [_vm._v("跳转至URL：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.bannerForm.clickEvent),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "clickEvent", $$v)
      },
      expression: "bannerForm.clickEvent"
    }
  }, [_vm._v("跳转至已有文章：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.bannerForm.clickEvent),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "clickEvent", $$v)
      },
      expression: "bannerForm.clickEvent"
    }
  }, [_vm._v("跳转至已有话题：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "6"
    },
    model: {
      value: (_vm.bannerForm.clickEvent),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "clickEvent", $$v)
      },
      expression: "bannerForm.clickEvent"
    }
  }, [_vm._v("跳转至已有活动：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "7"
    },
    model: {
      value: (_vm.bannerForm.clickEvent),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "clickEvent", $$v)
      },
      expression: "bannerForm.clickEvent"
    }
  }, [_vm._v("跳转至微信小程序：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "9"
    },
    model: {
      value: (_vm.bannerForm.clickEvent),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "clickEvent", $$v)
      },
      expression: "bannerForm.clickEvent"
    }
  }, [_vm._v("跳转至支付宝小程序：")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "8"
    },
    model: {
      value: (_vm.bannerForm.clickEvent),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "clickEvent", $$v)
      },
      expression: "bannerForm.clickEvent"
    }
  }, [_vm._v("跳转至音频：")])], 1), _vm._v(" "), (!_vm.shieldArray.includes(_vm.bannerForm.clickEvent)) ? _c('el-form-item', {
    attrs: {
      "prop": "keyWord"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.bannerForm.keyWord),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "keyWord", $$v)
      },
      expression: "bannerForm.keyWord"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bannerForm.clickEvent == '7') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from wx-app",
    attrs: {
      "label": "小程序原始ID：",
      "prop": "wxAppId",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的小程序原始ID"
    },
    model: {
      value: (_vm.bannerForm.wxAppId),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "wxAppId", $$v)
      },
      expression: "bannerForm.wxAppId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "路径地址："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的路径地址"
    },
    model: {
      value: (_vm.bannerForm.wxAppUrl),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "wxAppUrl", $$v)
      },
      expression: "bannerForm.wxAppUrl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.bannerForm.clickEvent == '9') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from wx-app",
    attrs: {
      "label": "小程序原始ID：",
      "prop": "aliAppId",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的小程序原始ID"
    },
    model: {
      value: (_vm.bannerForm.aliAppId),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "aliAppId", $$v)
      },
      expression: "bannerForm.aliAppId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "路径地址："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写正确的路径地址"
    },
    model: {
      value: (_vm.bannerForm.aliAppUrl),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "aliAppUrl", $$v)
      },
      expression: "bannerForm.aliAppUrl"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.bannerForm.clickEvent == '8') ? _c('div', {
    staticClass: "wx-app"
  }, [_c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "专辑ID：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写专辑ID"
    },
    model: {
      value: (_vm.bannerForm.albumId),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "albumId", $$v)
      },
      expression: "bannerForm.albumId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from wx-app",
    attrs: {
      "label": "主播名称：",
      "prop": "nickName",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写主播名称"
    },
    model: {
      value: (_vm.bannerForm.nickName),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "nickName", $$v)
      },
      expression: "bannerForm.nickName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "单曲数：",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写单曲数",
      "type": "number"
    },
    model: {
      value: (_vm.bannerForm.albumCount),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "albumCount", $$v)
      },
      expression: "bannerForm.albumCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "wxApp-from",
    attrs: {
      "label": "是否付费：",
      "prop": "isPaid",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.bannerForm.isPaid),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "isPaid", $$v)
      },
      expression: "bannerForm.isPaid"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.bannerForm.isPaid),
      callback: function($$v) {
        _vm.$set(_vm.bannerForm, "isPaid", $$v)
      },
      expression: "bannerForm.isPaid"
    }
  }, [_vm._v("否")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('select-school', {
    attrs: {
      "schObj": _vm.bannerForm.schObj
    },
    on: {
      "changeVal": _vm.getVal
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c3f4234!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/banner/newBanner.vue
// module id = 1014
// module chunks = 0